import React, { useMemo, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { CardProduct } from "../../components/CardProduct";
import { secondProducts } from "./cadsdata.js";

export const HomePageSolution = () => {
  const { t } = useTranslation();
  const [currentPanel, setCurrentPanel] = useState("firstPanel");
  const tabs = useMemo(() => {
    return [
      {
        value: "firstPanel",
        label: t("homePage.solution.tabs.tab1.label"),
        icon:
          "//files.authing.co/authing-website/home-0830-4-1-icon-3-t-t-t.png",
        desc: t("homePage.solution.tabs.tab1.desc"),
      },
      // {
      //   value: "secondPanel",
      //   label: "应用解决方案",
      // icon: "//files.authing.co/authing-website/home-0830-4-small-2.png",
      //   desc: "你所用的应用，简单配置即可统一认证",
      // },
      {
        value: "thirdPanel",
        label: t("homePage.solution.tabs.tab3.label"),
        icon: "//files.authing.co/authing-website/home-0830-4-1-icon-1-t-t.png",
        desc: t("homePage.solution.tabs.tab3.desc"),
      },
    ];
  }, [t]);
  const firstProducts = [
    {
      icon: "//files.authing.co/authing-website/home-0915-01.png",
      title: t("homePage.solution.firstProducts.firstProducts1.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts1.subtitle"),
      bgimg: "//files.authing.co/authing-website/home-0830-4-1-img1-e.png",
      widthPercent: 2,
      detailUrl: "/solutions/software",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-02.png",
      title: t("homePage.solution.firstProducts.firstProducts2.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts2.subtitle"),
      bgimg: "//files.authing.co/authing-website/home-0830-4-1-img2-e.png",
      widthPercent: 2,
      detailUrl: "/solutions/manufacturing",
      fromTag: "manufacturing",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-03.png",
      title: t("homePage.solution.firstProducts.firstProducts3.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts3.subtitle"),
      bgimg: "//files.authing.co/authing-website/home-0830-4-1-img3-e.png",
      widthPercent: 2,
      detailUrl: "/solutions/finance",
      fromTag: "finance",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-04.png",
      title: t("homePage.solution.firstProducts.firstProducts4.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts4.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/medical",
      fromTag: "medical",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-05.png",
      title: t("homePage.solution.firstProducts.firstProducts5.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts5.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/consume",
      fromTag: "consume",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-06.png",
      title: t("homePage.solution.firstProducts.firstProducts6.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts6.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-07.png",
      title: t("homePage.solution.firstProducts.firstProducts7.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts7.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/game",
      fromTag: "game",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-08.png",
      title: t("homePage.solution.firstProducts.firstProducts8.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts8.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/education",
      fromTag: "education",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-09.png",
      title: t("homePage.solution.firstProducts.firstProducts9.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts9.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/automotive",
      fromTag: "automotive",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-10.png",
      title: t("homePage.solution.firstProducts.firstProducts10.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts10.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/enterprise",
      fromTag: "enterprise",
    },
    {
      icon: "//files.authing.co/authing-website/home-0915-11.png",
      title: t("homePage.solution.firstProducts.firstProducts11.title"),
      subtitle: t("homePage.solution.firstProducts.firstProducts11.subtitle"),
      width: `calc((100% - 96px) * 0.25`,
      detailUrl: "/solutions/government",
      fromTag: "government",
    },
  ];
  const thirdProducts = [
    {
      type: "vertical",
      size: "middle",
      icon: "//files.authing.co/authing-website/home-0915-3-01.png",
      title: t("homePage.solution.thirdProducts.thirdProducts1.title"),
      subtitle: t("homePage.solution.thirdProducts.thirdProducts1.subtitle"),
      contentList: [
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon1.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts1.contentListValue1"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon2.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts1.contentListValue2"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon3.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts1.contentListValue3"
          ),
        },
      ],
      img: "//files.authing.co/authing-website/homo-0830-4-3-mg1-e.png",
      detailUrl: "/solutions/ad",
      fromTag: "ad",
    },
    {
      type: "vertical",
      size: "middle",
      icon: "//files.authing.co/authing-website/home-0915-3-02.png",
      title: t("homePage.solution.thirdProducts.thirdProducts2.title"),
      subtitle: t("homePage.solution.thirdProducts.thirdProducts2.subtitle"),
      contentList: [
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon1.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts2.contentListValue1"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon2.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts2.contentListValue2"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon3.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts2.contentListValue3"
          ),
        },
      ],
      img: "//files.authing.co/authing-website/homo-0830-4-3-mg2-e.png",
      detailUrl: "/solutions/okta",
      fromTag: "okta",
    },
    {
      type: "vertical",
      size: "middle",
      icon: "//files.authing.co/authing-website/home-0915-3-03.png",
      title: t("homePage.solution.thirdProducts.thirdProducts3.title"),
      subtitle: t("homePage.solution.thirdProducts.thirdProducts3.subtitle"),
      contentList: [
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon1.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts3.contentListValue1"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon2.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts3.contentListValue2"
          ),
        },
        {
          img: "//files.authing.co/authing-website/home-0830-4-3-icon3.png",
          value: t(
            "homePage.solution.thirdProducts.thirdProducts3.contentListValue3"
          ),
        },
      ],
      img: "//files.authing.co/authing-website/homo-0830-4-3-mg3-e.png",
      detailUrl: "/solutions/cognito",
      fromTag: "cognito",
    },
  ];
  return (
    <div className="home-page-solution">
      <div className="basic-column">
        <div className="home-page-solution-title basic-title">
          {t("homePage.solution.title")}
        </div>
        <div className="home-page-solution-tabs">
          {tabs.map((tab, tabIndex) => (
            <div
              className={classNames({
                "home-page-solution-tab": true,
                active: currentPanel === tab.value,
              })}
              onClick={() => setCurrentPanel(tab.value)}
              key={tab.value}
            >
              <div className="solution-tab-icon" style={tab.iconStyle}>
                <img src={tab.icon} alt="" />
              </div>
              <div className="solution-tab-label">{tab.label}</div>
              {currentPanel === tab.value && (
                <div
                  className={classNames("solution-tab-link", {
                    self__backInLeft: tabIndex === 1,
                    self__backInRight: tabIndex === 0,
                  })}
                ></div>
              )}
            </div>
          ))}
        </div>
      </div>
      {currentPanel === "firstPanel" && (
        <div
          className={classNames("home-page-solution-content-block", {
            // self__backInLeft: true,
          })}
        >
          <div className="home-page-solution-content-title">
            {tabs.find((item) => item.value === currentPanel)?.desc}
          </div>
          <div className="basic-column">
            <div className="home-page-solution-content-warp tab1">
              {firstProducts.map((item) => {
                return <CardProduct {...item} exchange key={item.title} />;
              })}
            </div>
          </div>
        </div>
      )}
      {currentPanel === "secondPanel" && (
        <div
          className={classNames(
            "home-page-solution-content-block"
            // "self__backInRight"
          )}
        >
          <div className="home-page-solution-content-title">
            {tabs.find((item) => item.value === currentPanel)?.desc}
          </div>
          <div className="basic-column">
            <div className="home-page-solution-content-warp tab2">
              {secondProducts.map((item) => {
                return (
                  <CardProduct
                    width={`calc((100% - 48px) * 0.50`}
                    {...item}
                    key={item.title}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}
      {currentPanel === "thirdPanel" && (
        <div
          className={classNames(
            "home-page-solution-content-block"
            // "self__backInRight"
          )}
        >
          <div className="home-page-solution-content-title">
            {tabs.find((item) => item.value === currentPanel)?.desc}
          </div>
          <div className="basic-column">
            <div className="home-page-solution-content-warp tab3">
              {thirdProducts.map((item) => {
                return (
                  <CardProduct {...item} key={item.title} widthPercent={2} />
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
